import Modal from "common/components/Modal";
import Select from "common/components/Select";
import axios from "common/configs/axiosConfigs";
import React, { useState } from "react";
import { toast } from "react-toastify";

const CreateTodo = ({ isOpen, onClose, startDate }) => {
  const { company_id } = JSON.parse(localStorage.getItem("user-auth"));
  const [values, setValues] = useState({
    task: "",
    isGeneral: 1,
    companyId: company_id,
    taskDate: startDate.toISOString(),
  });
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post("", {
        action: "addTodo",
        ...values,
      });
      if (data?.success) {
        toast.success(data?.msg);
        onClose();
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handleInput = ({ target: { name, value } }) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };
  return (
    <Modal {...{ title: "Add Todo", isOpen, onClose }}>
      <form onSubmit={handleSubmit}>
        <div className="row gy-4">
          <div className="col-12">
            <label>
              <span className="label">Task Title</span>
              <input
                type="text"
                className="form-control"
                name="task"
                value={values.task}
                onChange={handleInput}
                placeholder="Task title"
                required
              />
            </label>
          </div>
          <div className="col-lg-6">
            <label>
              <span className="label">Privacy</span>
              <Select
                options={[
                  { label: "Private", value: 0 },
                  { label: "Public", value: 1 },
                ]}
                name="isGeneral"
                value={values.isGeneral}
                onChange={handleInput}
              />
            </label>
          </div>
          <div className="col-lg-6">
            <label>
              <span className="label">Task timeline</span>
              <input
                className="form-control"
                type="datetime-local"
                name="taskDate"
                value={values.taskDate}
                onChange={handleInput}
              />
            </label>
          </div>
        </div>
        <label className="mt-3">
          <span className="label">Description</span>
          <textarea
            type="text"
            rows="5"
            name="description"
            className="form-control"
            value={values.description}
            onChange={handleInput}
            placeholder="Description"
          />
        </label>
        <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
          <button type="button" className="btn btn-light me-2">
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Add
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CreateTodo;
